import { useGetSitecoreContextId } from '../api/useGetSitecoreContextId';
import { useMemo } from 'react';
import { validResources } from '../utils';

export const useEnhancedResources = (sitecoreContextId: string) => {
  const {
    data,
    isLoading: isContextLoading,
    error,
  } = useGetSitecoreContextId({ sitecoreContextId });

  const updatedResources = useMemo(
    () =>
      data?.resources
        ?.filter(
          ({ tenantProductCode }) =>
            validResources[
              tenantProductCode.toLowerCase() as keyof typeof validResources
            ],
        )
        .map((resource) => {
          if (resource.type === 'site') {
            const siteProperty = resource.properties.find(
              ({ id }) => id === 'site',
            )?.value;
            return {
              ...resource,
              tenantDisplayName: siteProperty
                ? `${resource.tenantName} - ${siteProperty}`
                : resource.tenantName,
              name: 'Site identifier',
            };
          }

          return {
            ...resource,
            tenantDisplayName: resource.tenantName,
            name: resource.name?.split(/\s+/)?.[1],
          };
        }) ?? [],
    [data],
  );

  return useMemo(
    () => ({ updatedResources, isLoading: isContextLoading, error }),
    [updatedResources, isContextLoading, error],
  );
};
